import { observer } from "mobx-react";
import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import AdviceTimelinePageStore from "pages/AdviceTimelinePage/store/AdviceTimelinePageStore";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {},
};

interface Props {
  pageStore: AdviceTimelinePageStore;
}
function AdviceTimelineGraphView(props: Props) {
  const data = {
    labels: props.pageStore.labels,
    datasets: [
      {
        label: "평균 평가 점수",
        data: props.pageStore.scores,
        fill: false,
        borderColor: "#2281D0",
        tension: 0.1,
      },
    ],
  };

  return (
    <>
      <Line options={options} data={data} />
    </>
  );
}

export default observer(AdviceTimelineGraphView);
